<div class="page-content-container h-100 mt-4">
  <div class="top-content">
    <div class="w-100">

    <!-- Header -->
    <div class="bob-header">
      <button mat-stroked-button class="back-btn" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Back to Dashboard
      </button>
      <h1 class="bob-title">Book of Business</h1>
      <p class="bob-subtitle">View client portfolios and product details</p>
    </div>

    <!-- Search -->
    <mat-card class="search-card">
      <div class="search-input-wrap">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          class="search-input"
          placeholder="Search by client name, member ID, agent name, or NPN..."
          [ngModel]="searchTerm"
          (ngModelChange)="onSearch($event)"
        />
      </div>
    </mat-card>

    <!-- Export CSV Panel -->
    <mat-card class="export-card">
      <div class="export-header">
        <div class="export-title">
          <mat-icon class="export-icon">download</mat-icon>
          <span class="export-label">Export Product Records</span>
        </div>
        <button mat-stroked-button class="filter-toggle-btn" (click)="showExportPanel = !showExportPanel">
          <mat-icon>filter_list</mat-icon>
          {{ showExportPanel ? 'Hide Filters' : 'Show Filters' }}
        </button>
      </div>

      @if (showExportPanel) {
        <div class="filter-panel">
          <div class="filter-grid">
            <div class="filter-group">
              <label class="filter-label">Effective Date Range</label>
              <input type="date" class="date-input" [(ngModel)]="filterEffectiveDateFrom" placeholder="From" />
              <input type="date" class="date-input" [(ngModel)]="filterEffectiveDateTo" placeholder="To" />
            </div>
            <div class="filter-group">
              <label class="filter-label">Term Date Range</label>
              <input type="date" class="date-input" [(ngModel)]="filterTermDateFrom" placeholder="From" />
              <input type="date" class="date-input" [(ngModel)]="filterTermDateTo" placeholder="To" />
            </div>
          </div>
          <div class="filter-actions">
            @if (hasActiveFilters) {
              <button mat-stroked-button class="clear-btn" (click)="clearFilters()">
                <mat-icon>close</mat-icon>
                Clear Filters
              </button>
            }
            <span class="filter-status">
              {{ hasActiveFilters ? 'Filters applied' : 'No filters applied — all records will be exported' }}
            </span>
          </div>
        </div>
      }

      <button mat-flat-button class="download-btn" (click)="downloadCsv()">
        <mat-icon>download</mat-icon>
        Download CSV Report
      </button>
    </mat-card>

    <!-- Summary Stats -->
    <div class="stats-grid">
      <mat-card class="stat-card">
        <div class="stat-value">{{ filteredClients.length }}</div>
        <div class="stat-label">Total Clients</div>
      </mat-card>
<mat-card class="stat-card">
        <div class="stat-value">${{ totalMonthlyPremium | number:'1.2-2' }}</div>
        <div class="stat-label">Monthly Premium</div>
      </mat-card>
      <mat-card class="stat-card">
        <div class="stat-value">{{ totalStates }}</div>
        <div class="stat-label">States</div>
      </mat-card>
    </div>

    <!-- Client List -->
    <div class="client-list">
      @for (client of paginatedData; track client.clientId) {
        <mat-card class="client-card">

          <!-- Client Row -->
          <div class="client-row" (click)="toggleClient(client.clientId)">
            <mat-icon class="chevron-icon">
              {{ expandedClients[client.clientId] ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            <div class="client-info">
              <span class="client-name">{{ client.clientName }}</span>
              <div class="client-meta">
                <span class="meta-highlight">ID: {{ client.memberId }}</span>
                <span class="meta-dot">•</span>
                <span class="meta-highlight">{{ client.packageName }}</span>
                <span class="meta-dot">•</span>
                <span class="meta-bold">${{ client.totalMonthly | number:'1.2-2' }}/month</span>
                <span class="meta-dot">•</span>
                <span>{{ client.state }}</span>
                <span class="meta-dot">•</span>
                <span class="meta-highlight">Agent: {{ client.agentName }} (NPN: {{ client.agentNPN }})</span>
                <span class="meta-dot">•</span>
                <span class="meta-highlight">Status: {{ client.statusType }}</span>
                <span class="meta-dot">•</span>
                <span class="meta-highlight">Paid to Date: {{ client.paidToDate | date:'yyyy-MM-dd' }}</span>
              </div>
            </div>
          </div>

          <!-- Expanded Details -->
          @if (expandedClients[client.clientId]) {
            <div class="client-details">

              <!-- Participants Section -->
              <div class="detail-section">
                <div class="section-toggle" (click)="toggleParticipants(client.clientId)">
                  <mat-icon class="chevron-icon">
                    {{ expandedParticipants[client.clientId] ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                  <span class="section-title">Participants ({{ client.participants.length }})</span>
                </div>

                @if (expandedParticipants[client.clientId]) {
                  <div class="participants-list">
                    @for (p of client.participantsSorted; track p.participantId) {
                      <div class="participant-card">
                        <div class="participant-header">
                          <div>
                            <div class="participant-name-row">
                              <span class="participant-name">{{ p.name }}</span>
                              <span class="role-badge">{{ p.role }}</span>
                            </div>
                            <div class="participant-meta">
                              <span><span class="meta-key">Gender:</span> {{ p.gender }}</span>
                              <span><span class="meta-key">DOB:</span> {{ p.dob }}</span>
                            </div>
                          </div>
                        </div>
                        @if (p.role === 'Primary') {
                          <div class="participant-contact">
                            <div class="contact-grid">
                              <div><span class="meta-key">Address:</span> {{ p.address }}</div>
                              <div><span class="meta-key">City:</span> {{ p.city }}, {{ p.state }} {{ p.zip }}</div>
                              @if (p.phone) {
                                <div><span class="meta-key">Phone:</span> {{ p.phone }}</div>
                              }
                              @if (p.email) {
                                <div><span class="meta-key">Email:</span> {{ p.email }}</div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Benefits Section -->
              <div class="detail-section">
                <div class="section-toggle" (click)="toggleBenefits(client.clientId)">
                  <mat-icon class="chevron-icon">
                    {{ expandedBenefits[client.clientId] ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                  <span class="section-title">Benefits ({{ client.visibleBenefitsSorted.length }})</span>
                </div>

                @if (expandedBenefits[client.clientId]) {
                  <div class="benefits-table-wrap">
                    <table class="benefits-table">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Benefit Name</th>
                          <th class="text-right">Amount</th>
                          <th>Effective</th>
                          <th>Term</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (b of client.visibleBenefitsSorted; track b.benefitId) {
                          <tr>
                            <td><span class="product-name">{{ b.productName }}</span></td>
                            <td>{{ b.benefitName }}</td>
                            <td class="text-right">{{ formatAmount(b.amount) }}</td>
                            <td class="date-cell">{{ b.effectiveDate }}</td>
                            <td class="date-cell">{{ b.termDate }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>

            </div>
          }

        </mat-card>
      }

      @if (isLoading) {
        <mat-card class="empty-card">
          <p class="empty-text">Loading...</p>
        </mat-card>
      }
      @if (!isLoading && filteredClients.length === 0) {
        <mat-card class="empty-card">
          <p class="empty-text">No clients found matching your search.</p>
        </mat-card>
      }
    </div>

    <!-- Pagination -->
    @if (totalPages > 1) {
      <div class="pagination-bar">
        <div class="pagination-per-page">
          <span class="pag-label">Show:</span>
          <select class="pag-select" [ngModel]="itemsPerPage" (ngModelChange)="setItemsPerPage($event)">
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
          </select>
          <span class="pag-label">clients</span>
        </div>

        <div class="pag-info">
          Showing {{ startIndex + 1 }}–{{ endIndex }} of {{ filteredClients.length }}
        </div>

        <div class="pag-controls">
          <button mat-icon-button class="pag-btn" [disabled]="currentPage === 1" (click)="currentPage = 1">
            <mat-icon>first_page</mat-icon>
          </button>
          <button mat-icon-button class="pag-btn" [disabled]="currentPage === 1" (click)="currentPage = currentPage - 1">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="pag-pages">Page {{ currentPage }} of {{ totalPages }}</span>
          <button mat-icon-button class="pag-btn" [disabled]="currentPage === totalPages" (click)="currentPage = currentPage + 1">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-icon-button class="pag-btn" [disabled]="currentPage === totalPages" (click)="currentPage = totalPages">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>
      </div>
    }

    </div>
  </div>
</div>
